export function authUserFilterQueryKey({ authToken }: { authToken: string | undefined }) {
  return {
    authToken,
  };
}
